import { topics } from "@/mocks/topics";
import { TopicCard } from "@/components/base/TopicCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function TopicGrid() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="全部话题"
        title="正在被讨论的爆料"
        subtitle="每个话题都配有事件梳理、观点交锋、高能评论与投票结果，点开任意一张卡片即可进入完整的讨论现场。"
        linkTo="/topics"
        linkLabel="按分类浏览"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((topic, index) => (
          <TopicCard key={topic.id} topic={topic} rank={index + 1} />
        ))}
      </div>
    </section>
  );
}